(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.smFbtInitialized === 'true') return;
      root.dataset.smFbtInitialized = 'true';

      const checks = Array.from(root.querySelectorAll('[data-sm-fbt-check]'));
      const totalNode = root.querySelector('[data-sm-fbt-total]');
      const countNode = root.querySelector('[data-sm-fbt-count]');
      const addButton = root.querySelector('[data-sm-fbt-add]');
      const statusNode = root.querySelector('[data-sm-fbt-status]');
      const moneyFormat = root.dataset.moneyFormat || 'LE __amount__';

      const formatMoney = (cents) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(Number(cents) || 0, moneyFormat);
        }

        const amount = ((Number(cents) || 0) / 100).toFixed(2);
        return moneyFormat
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(amount))))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/g, amount)
          .replace(/__amount__/g, amount);
      };

      const setStatus = (message, state) => {
        if (!statusNode) return;
        statusNode.textContent = message || '';
        statusNode.classList.toggle('is-error', state === 'error');
        statusNode.classList.toggle('is-success', state === 'success');
      };

      const updateSummary = () => {
        const selected = checks.filter((check) => check.checked && !check.disabled);
        const total = selected.reduce((sum, check) => sum + (Number(check.dataset.price) || 0), 0);
        if (totalNode) totalNode.innerHTML = formatMoney(total);
        if (countNode) countNode.textContent = `${selected.length} ${selected.length === 1 ? 'piece selected' : 'pieces selected'}`;
        if (addButton) addButton.disabled = selected.length === 0;
      };

      root.querySelectorAll('[data-sm-fbt-variant]').forEach((select) => {
        select.addEventListener('change', () => {
          const item = select.closest('[data-sm-fbt-item]');
          const check = item && item.querySelector('[data-sm-fbt-check]');
          const priceNode = item && item.querySelector('[data-sm-fbt-price]');
          const option = select.options[select.selectedIndex];
          if (!check || !option) return;

          check.dataset.variantId = option.value;
          check.dataset.price = option.dataset.price || '0';

          if (priceNode) {
            const price = Number(option.dataset.price) || 0;
            const comparePrice = Number(option.dataset.comparePrice) || 0;
            priceNode.innerHTML = `<span class="sm-fbt__price-current">${formatMoney(price)}</span>${comparePrice > price ? `<s class="sm-fbt__price-compare">${formatMoney(comparePrice)}</s>` : ''}`;
          }
          updateSummary();
        });
      });

      checks.forEach((check) => check.addEventListener('change', updateSummary));

      if (addButton) {
        addButton.addEventListener('click', async () => {
          const items = checks
            .filter((check) => check.checked && !check.disabled)
            .map((check) => ({ id: Number(check.dataset.variantId), quantity: 1 }))
            .filter((item) => Number.isFinite(item.id) && item.id > 0);

          if (!items.length) {
            setStatus(root.dataset.emptyMessage || 'Select at least one piece.', 'error');
            return;
          }

          addButton.disabled = true;
          addButton.classList.add('is-loading');
          addButton.setAttribute('aria-busy', 'true');
          setStatus('', '');

          try {
            const cartDrawer = document.querySelector('cart-drawer');
            const payload = { items };

            if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
              payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
              payload.sections_url = window.location.pathname;
              if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(addButton);
            }

            const addUrl = window.routes?.cart_add_url || '/cart/add.js';
            const response = await fetch(addUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(payload)
            });
            const data = await response.json();

            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || root.dataset.errorMessage || 'The selected pieces could not be added.');
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'sm-frequently-bought-together',
                productVariantId: items[0]?.id,
                cartData: data
              });
            }

            if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
              cartDrawer.renderContents(data);
            } else if (window.routes?.cart_url) {
              window.location.href = window.routes.cart_url;
              return;
            }

            setStatus(root.dataset.successMessage || 'Selected pieces were added to your bag.', 'success');
          } catch (error) {
            setStatus(error?.message || root.dataset.errorMessage || 'The selected pieces could not be added.', 'error');
          } finally {
            addButton.classList.remove('is-loading');
            addButton.removeAttribute('aria-busy');
            updateSummary();
          }
        });
      }

      updateSummary();
    };

    document.querySelectorAll('[data-sm-fbt-root]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-sm-fbt-root]').forEach(initialize);
      if (event.target.matches?.('[data-sm-fbt-root]')) initialize(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
